// extracted by mini-css-extract-plugin
export default {"container":"iT5u4EDjgE9793AsKbSE","explanation":"AL7qUwuTENLV1SmefpVP","arrow":"ni0_tL293AK1t7OnakcI"};